//@ts-nocheck
import React, { forwardRef } from 'react';
import { Checkbox, ConfigProvider } from 'antd';
import './components.scss';

type Props = {
  disabled?: boolean;
  children?: React.ReactNode;
} & React.ComponentProps<typeof Checkbox>;

const CustomCheckbox = forwardRef<HTMLInputElement, Props>(
  ({ disabled, children, value, ...props }: Props, ref) => {
    return (
      <ConfigProvider
        theme={{
          token: {
            colorBgContainer: disabled ? '#f00' : '#FFFFFF',
            colorPrimary: '#FD9FFD',
            colorBorder: disabled ? '#DFE4EA' : '#DFE4EA',
            borderRadiusSM: 4,
          },
          components: {
            Checkbox: {
              colorPrimary: '#FD9FFD',
              colorPrimaryHover: '#FD9FFD',
              borderRadiusSM: 4,
            },
          },
        }}
      >
        <Checkbox
          disabled={disabled}
          className="dark:text-white [&_.ant-checkbox-inner]:!w-[20px] [&_.ant-checkbox-inner]:!h-[20px] [&_.ant-checkbox-inner]:!rounded-[4px] [&_.ant-checkbox-inner]:!border-[#DFE4EA] [&_.ant-checkbox-checked_.ant-checkbox-inner]:!border-[#FD9FFD] [&_.ant-checkbox-inner]:after:!w-[6px] [&_.ant-checkbox-inner]:after:!h-[10px]"
          {...props}
          ref={ref}
          checked={props.checked !== undefined ? props.checked : value}
        >
          {children}
        </Checkbox>
      </ConfigProvider>
    );
  }
);
CustomCheckbox.displayName = 'CustomCheckbox';

export default CustomCheckbox;
